export default {
    data() {
        return {
            eventBus: new Vue(),
            jwtToken: ''
        }
    },

    mounted() {
        this.getToken();
    },

    methods: {
        getToken() {
            axios.get('/jwt/token?rand=' + Math.random() * 100)
                .then(response => {
                    this.jwtToken = response.data.token;
                })
                .finally(() => {
                    this.eventBus.$emit('alive', 'ticktock');
                });
        }
    }
}
